import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { ConsentTableRecordCookiePolicy, ConsentTableRecordSettings } from ".";
import { __ } from "../../../../utils";
import { ConsentTableRecordPreview, ConsentTableRecordExport } from ".";
import { Row, Col, Spin } from "antd";
const ConsentTableRecordExpand = observer((param)=>{
    let { record, onPreview } = param;
    const [loaded, setLoaded] = useState(false);
    const { referer, context, viewport_width, viewport_height, forwarded } = record;
    // Ensure to load the revisions of this entry
    useEffect(()=>{
        record.fetchRevisions().then(()=>{
            setLoaded(true);
        });
    }, [
        record
    ]);
    return loaded ? /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            __("Viewport (px)"),
                            ":"
                        ]
                    }),
                    " ",
                    viewport_width,
                    " x ",
                    viewport_height
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            __("Viewed page"),
                            ":"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("a", {
                        href: referer,
                        rel: "noopener noreferrer",
                        target: "_blank",
                        children: referer
                    })
                ]
            }),
            !!context && /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs("strong", {
                        children: [
                            __("Context"),
                            ":"
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ _jsx("code", {
                        children: context
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ConsentTableRecordSettings, {
                record: record
            }),
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(Col, {
                        md: forwarded ? undefined : 12,
                        sm: forwarded ? undefined : 24,
                        span: forwarded ? 24 : undefined,
                        children: /*#__PURE__*/ _jsx("div", {
                            style: {
                                padding: 10
                            },
                            children: /*#__PURE__*/ _jsx(ConsentTableRecordPreview, {
                                record: record,
                                onPreview: onPreview
                            })
                        })
                    }),
                    !forwarded && /*#__PURE__*/ _jsxs(Col, {
                        md: 12,
                        sm: 24,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    padding: 10
                                },
                                children: /*#__PURE__*/ _jsx(ConsentTableRecordExport, {
                                    record: record
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                style: {
                                    padding: 10
                                },
                                children: /*#__PURE__*/ _jsx(ConsentTableRecordCookiePolicy, {
                                    record: record
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ _jsx(Spin, {
        spinning: true
    });
});
export { ConsentTableRecordExpand };
